import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '@templatean/shared/hooks'

const HomePage: React.FC = () => {
  const { user } = useAuth()

  return (
    <div className="home-page">
      <div className="welcome-section">
        <h1>Welcome to Templatean for Word</h1>
        <p>Hello {user?.fullName}, enhance your documents with AI-powered templates and content generation.</p>
      </div>

      <div className="features-grid">
        <Link to="/templates" className="feature-card">
          <div className="feature-icon">📄</div>
          <h3>Templates</h3>
          <p>Access and insert pre-built templates for various document types.</p>
        </Link>

        <Link to="/assets" className="feature-card">
          <div className="feature-icon">🖼️</div>
          <h3>Digital Assets</h3>
          <p>Browse and insert images, logos, and other media from your library.</p>
        </Link>

        <Link to="/ai-studio" className="feature-card">
          <div className="feature-icon">🤖</div>
          <h3>AI Studio</h3>
          <p>Generate content, enhance writing, and get AI-powered suggestions.</p>
        </Link>

        <Link to="/settings" className="feature-card">
          <div className="feature-icon">⚙️</div>
          <h3>Settings</h3>
          <p>Configure preferences and manage your account settings.</p>
        </Link>
      </div>

      <div className="quick-tips">
        <h2>Quick Tips</h2>
        <ul>
          <li>Use the Task Pane for quick access to templates while editing</li>
          <li>Press Ctrl+Space to open AI suggestions</li>
          <li>Drag and drop assets directly into your document</li>
          <li>Create custom templates from your existing documents</li>
        </ul>
      </div>

      <div className="cta-section">
        <button
          onClick={() => {
            // Office.ribbon.requestUpdate requires valid RibbonUpdaterData with tabs property
            // For now, just log the action - implement proper ribbon update when needed
            console.log('Open Task Pane clicked')
          }}
          className="btn btn-primary"
        >
          Open Task Pane
        </button>
      </div>
    </div>
  )
}

export default HomePage